'use client';

export const USER_STATE_STORAGE_KEY = 'ssv-user-state';

export const clearPersistedUserState = () => {
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(USER_STATE_STORAGE_KEY);
  }
};
